module.exports = __webpack_public_path__ + "img/ballet.7b092563.svg";